import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { useCustomColors } from "@circle-react-shared/BuilderUI/ThemeConfiguration/hooks/useCustomColors";
import { Row } from "../shared/Row";
import { resolveCssVariable } from "../utils/resolveCssVariable";
import { STYLES_COLORS } from "./constants";

export const Styles = () => {
  const appearance = useBuilderStore(state => state.appearance);
  const {
    customColors,
    handleAddCustomColor,
    themeColors,
    flattenedCssVariables,
  } = useCustomColors();

  return (
    <div className="divide-primary h-full w-[23rem] divide-y overflow-y-auto">
      <div className="flex flex-col gap-5 px-6 pt-5">
        {STYLES_COLORS.map(({ name, title, variable }) => (
          <Row
            key={name}
            title={title}
            value={resolveCssVariable({
              value: flattenedCssVariables[variable],
              cssVariables: flattenedCssVariables,
            })}
            name={`theme.${appearance}.${name}`}
            cssVariables={flattenedCssVariables}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={handleAddCustomColor}
          />
        ))}
      </div>
    </div>
  );
};
